// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
  message: {
    title: "运动品牌",
  },
  placeholder: {
    enter: "请输入您喜欢的品牌",
  },
  brands: {
    nike: "耐克",
    adi: "阿迪达斯",
    nb: "新百伦",
    ln: "李宁",
  },
  menue: {
    detail: "社交详情",
    find: "增长发现",
    porj: "预设方案",
    custom: "自定义管理",
    report: "行业报告",
    setting: "设置",
  },
  topHead: {
    select_option_category: "类目",
    select_option_category_holder: "请选择类目",
    select_option_brand: "品牌",
    select_option_brand_holder: "请选择",
    select_option_topic: "话题",
    select_option_topic_holder: "请输入内容",
    select_option_postKeyWords: "帖子关键词",
    select_option_postKeyWords_holder: "请输入内容",
    rules_message_search: "品牌和帖子内容至少输入一个",
    my_attention: "我的关注",
    login_label: "登录",
    login_out: "退出",
    Chinese: "中文",
    English: "English",
  },
  mainHead: {
    eidtTooltip: "编辑搜索条件",
    platList_weibo: "微博",
    platList_douyin: "抖音",
    platList_xhs: "小红书",
    platList_bzhan: "B站",
    platList_kuaishou: "快手",
    platList_weixin: "微信",
    platList_jrtt: "今日头条",
    platList_zhihu: "知乎",
    platList_dewu: "得物",
    platList_hupu: "虎扑",
    dateLabel: "时间",
    date_to: "至",
    date_holder: "选择月",
    saveProj: "保存方案",
    tabs_baseInfo: "基本信息",
    tabs_crowdPortrait: "人群画像",
    tabs_talents: "达人榜",
    tabs_brand: "品牌榜",
    tabs_topic: "话题分析",
    tabs_custom: "自定义分析",
    tabs_ai: "DeepSeek解读",
    rules_message_search: "品牌、类目和帖子内容至少输入一个",
    rules_message_search2: "品牌、类目和帖子内容至少有一个不为空",
    rules_message_range: "时间范围不能为空",
    message_saveProj_success: "方案保存成功",
    message_saveProj_failed: "方案保存失败",
    headProductText: "为什么值得买：",
  },
  search: {
    title: "添加搜索条件",
    form_postWord: "帖子关键词",
    form_postWord_tip:
      "支持and、or、not逻辑，和分词用空格隔开；例如：口红 and （唇釉 or 唇彩）not 哑光",
    form_brand: "品牌",
    form_brand_holder: "输入品牌关键词",
    form_brand_tip:
      "例如：搜索品牌'苹果/Apple',会筛选出帖子中包含'苹果'或'Apple' 或 '苹果/Apple',且通过语意分析可确定其代表'苹果/Apple' 的帖子。",
    form_topic: "话题",
    form_topic_holder: "请输入话题词",
    form_category: "类目",
    form_cat_tip: "请选择需要查看的类目",
    form_plat: "平台",
    form_platOption_douyin: "抖音",
    form_platOption_weibo: "微博",
    form_platOption_xhs: "小红书",
    form_dateRange: "时间范围",
    form_dateRange_holder: "选择月",
    form_dateRange_to: "至",
    searchBtnLab: "搜  索",
    operation: "操作",
    form_user_name: "用户名",
  },
  baseInfo: {
    trend: "趋势",
    posts: "声量",
    posts_toolTip: "总发帖数",
    interaction: "互动量",
    interaction_toolTip: "评论数+点赞数+转发数",
    nsr: "NSR",
    nsr_toolTip:
      "NSR（净情感度）=（正面声量-负面声量）/(正面声量+负面声量）*100%",
    soe_toolTip: "soe",
    sov_toolTip: "sov",
    platTitle: "平台分布",
    cloudWordTitle: "词云图",
    TalentTitle: "达人Top10榜单",
    PostListLabel: "声量排行",
    IteractionListLabel: "互动量排行",
    BrandTitle: "品牌Top10榜单",
    postContent: "帖子原文",
    postType_all: "总",
    postType_Forward: "正向",
    postType_back: "负向",
    postType_neutral: "中性",
    selectedCondition: "已选中的条件",
    postKeyWordLabel: "帖子关键词：",
    mustKwLabel: "必选词：",
    shouldKwLabel: "可选词：",
    notKwLabel: "排除词：",
    kolWord: "用户名：",
    kolMustKwLabel: "用户名必选词：",
    kolShouldKwLabel: "用户名可选词：",
    kolNotKwLabel: "用户名排除词：",
    cloudWordLabel: "词云：",
    kolLabel: "KOL：",
    catLabel: "类目：",
    brandLabel: "品牌：",
    brand: "品牌",
    topic: "话题",
    topicLabel: "话题：",
    originPostLink: "原文链接",
    negativePostPercent: "负向声量占比",
    reposts: "转发数",
    comments: "评论数",
    zans: "点赞数",
    participle: "分词",
    frequency: "词频",
    photo: "头像",
    Talent: "达人",
    plant: "平台",
    fansNum: "粉丝数",
    downLoad: "下载",
    downLoading: "下载准备中...",
    ranking: "排名",
    cloud_nameLabel: "词",
    cloud_valueLabel: "数量",
    gender: "性别",
    age: "年龄",
    region: "地域",
    cityLevel: "城市级别",
    g_aspect: "情感正负",
    interest: "兴趣",
    interestStatistics: "兴趣原文词云及词频统计",
    distribution: "分布",
    concerned: "关注",
    category: "品类",
    user: "用户数",
    tgi: "TGI",
    man: "男性",
    woman: "女性",
    max: "最大",
    min: "最小",
    qoq: "环比",
    yoy: "同比",
    sentiment: "情感分析",
    fansProportion: "分平台粉丝占比",
    rate: "率",
    KOL: "KOL",
    KOC: "KOC",
    consumer: "消费者",
  },
  TalentList: {
    allPosts: "全部帖子",
    forwardPosts: "正向帖子",
    backPosts: "负向帖子",
    neutralPosts: "中性帖子",
  },
  brandList: {
    add: "新增",
    brand: "品牌",
    name: "名称",
    rule: "规则",
    confirm: "确定",
  },
  proj: {
    title: "预设方案",
    userDefinedName: "自定义名称",
    postsKeyWords: "帖子关键字",
    brand: "品牌",
    cat: "类目",
    Talent: "达人",
    plant: "平台",
    date: "时间",
    to: " 至 ",
  },
  setting: {
    phone_set: "手机号设置",
    mail_set: "邮箱设置",
    primary_number: "您的主手机号",
    mail_number: "您的邮箱号",
    second_number: "您的辅手机号",
    delete: "删除",
    phone_placeholder: "请输入内容",
    sms: "短信登录验证",
    add: "添加手机",
    add_mail: "添加邮箱",
    success: "手机号添加成功",
    confirm: "确 定",
    dialog_phone: "主手机号",
    dialog_input_placeholder: "输入验证码",
    verification: "验证",
    cancel: "取消",
    yesterday: "昨天",
    7: "近7天",
    30: "近30天",
    90: "近90天",
    enter_num: "请输入手机号",
    enter_mail: "请输入邮箱号",
    enter_correct_num: "请输入正确的手机号",
    enter_correct_mail: "请输入正确的邮箱",
    first_num: "第一个手机号必须开启短信登录验证",
    note: "备注",
    optional: "备注(选填)",
    desc: "海外手机号填写格式: +区号 手机号",
    example: "如: +852 61234567",
  },
  changePasswordPanel: {
    change_password_title: "修改密码 （仅主手机号可用）",
    change_password: "修改密码",
    use_latest_cat: "当平台类目结构发生变化时，使用最新类目结构统计历史数据",
    message_success: "修改成功",
  },
  userInfo: {
    enter_phone_title: "手机号验证",
    enter_email_title: "邮箱验证",
    enter_phone_placeholder: "请输入手机号",
    enter_email_placeholder: "请输入邮箱",
    enter_sms: "请输入验证码",
    get_sms: "获取验证码",
    verify: "验证",
    cancel: "取消",
  },
  footer: {
    content_one:
      "魔镜洞察的数据全部来自公开页面，魔镜洞察与淘宝、天猫、京东、亚马逊等电商平台无直接关联，是一家独立的第三方电商数据机构",
    content_two: "@2025 北京淘幂科技有限公司 ",
    content_icp: "京ICP备15061734号-4 ",
    content_goan: "京公网安备11010502037832号 ",
    content_add:
      "数据由公开页面采集并汇总处理，数据口径和平台及其他机构有所不同，仅供参考，如有差异请以平台官方发布数据为准",
  },
  downloadSelection: {
    table: "下载为表格",
    image: "下载为图片",
    bubble: "下载为气泡图",
    lineBar: "下载为柱线图",
    bar: "下载为柱状图",
    pie: "下载为饼图",
  },
};
